import CoordinateInput from "@/components/CoordinateInput"
import InstantInput from "@/components/form/InstantInput"
import type { IncidentLog } from "@/models"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	incident: IncidentLog
}

const IncidentLocation: ReactiveComponent<Props> = (props) => {
	return () => (
		<div class="inline-flex flex-col spacing-2">
			<label>
				Position Received At (UTC)
				<InstantInput value={props.incident.positions[0].receivedAt} setValue={() => void 0} disabled />
			</label>
			<div class="flex items-center spacing-8">
				<label>
					Incident Latitude
					<CoordinateInput
						value={props.incident.positions[0].position.latitude}
						setValue={() => void 0}
						type="latitude"
						disabled
					/>
				</label>
				<label>
					Incident Longitude
					<CoordinateInput
						value={props.incident.positions[0].position.longitude}
						setValue={() => void 0}
						type="longitude"
						disabled
					/>
				</label>
			</div>
		</div>
	)
}

export default defineComponent(IncidentLocation, inferProps<Props>())
